export default __webpack_public_path__ + "static/media/empty.d98a8095.svg";